import { combineEpicsAndCatchErrors } from "../../generic/redux/CombineEpicsAndCatchErrors";

import { ExecuteQueryEpic } from "./analytics/ExecuteQueryEpic";
import { StackPacksEpic } from "./entities/stackPacks/StackPacksEpic";
import { GlobalEpic } from "./global/GlobalEpic";
import { MergeViewParamsEpic } from "./route/MergeViewParamsEpic";
import {
	UsageGoogleTagManagerEpic,
	UsagePushEventsToGTMDataLayer,
	UsagePushPathChangeToGTMDataLayer,
} from "./usage-track/UsageGoogleTagManagerEpic";
import { UsageTrackPendoIOEpic } from "./usage-track/UsageTrackPendoEpic";
import { TimelineEpic } from "./view/timeline/TimelineEpic";

export const RootEpic = combineEpicsAndCatchErrors(
	GlobalEpic,
	StackPacksEpic,
	ExecuteQueryEpic,
	TimelineEpic,
	MergeViewParamsEpic,
	UsageGoogleTagManagerEpic,
	UsagePushPathChangeToGTMDataLayer,
	UsagePushEventsToGTMDataLayer,
	UsageTrackPendoIOEpic,
);
